import { UseFormReturn } from "react-hook-form";
import { date } from "services";
import { tankaKbn } from "services/codes";
import { B000200Get } from "../b000/B000200";
import { B010010GetWhTanka } from "../b010/B010010";
import { catchRestError, RestClient } from "../RestClient";
import { B100140Jodaitanka } from "./B100140";

export type B100180FindRequest = {
  modeKbn: string;
  whtankaKbn: string;
  whtankaCd: string;
};

export type B100180FindResponse = {
  whtankaNm: string;
  height: string;
  width1: string;
  width2: string;
  width3: string;
  width4: string;
  width5: string;
  width6: string;
  width7: string;
  width8: string;
  width9: string;
  width10: string;
  width11: string;
  width12: string;
  width13: string;
  width14: string;
  width15: string;
  width16: string;
  width17: string;
  width18: string;
  width19: string;
  width20: string;
  width21: string;
  width22: string;
  width23: string;
  width24: string;
  width25: string;
  width26: string;
  width27: string;
  width28: string;
  width29: string;
  width30: string;
  width31: string;
  width32: string;
  width33: string;
  width34: string;
  width35: string;
  width36: string;
  width37: string;
  width38: string;
  width39: string;
  width40: string;
  width41: string;
  width42: string;
  width43: string;
  width44: string;
  width45: string;
  width46: string;
  width47: string;
  width48: string;
  width49: string;
  version: string;
};

export const B100180Find = (props: B100180FindRequest) => {
  return RestClient.get<B100180FindResponse[]>("b100180/find", {
    params: props,
  });
};

export type B100180CreateRequest = {
  whtankaKbn: string;
  whtankaCd: string;
  meishoNm1: string;
  // 明細
  b100180CreateFieldList: B100180CreateMeiRequest[];
} & Partial<{}>;

export type B100180CreateMeiRequest = {
  height: string;
} & Partial<{
  width1: string;
  width2: string;
  width3: string;
  width4: string;
  width5: string;
  width6: string;
  width7: string;
  width8: string;
  width9: string;
  width10: string;
  width11: string;
  width12: string;
  width13: string;
  width14: string;
  width15: string;
  width16: string;
  width17: string;
  width18: string;
  width19: string;
  width20: string;
  width21: string;
  width22: string;
  width23: string;
  width24: string;
  width25: string;
  width26: string;
  width27: string;
  width28: string;
  width29: string;
  width30: string;
  width31: string;
  width32: string;
  width33: string;
  width34: string;
  width35: string;
  width36: string;
  width37: string;
  width38: string;
  width39: string;
  width40: string;
  width41: string;
  width42: string;
  width43: string;
  width44: string;
  width45: string;
  width46: string;
  width47: string;
  width48: string;
  width49: string;
  version: string;
}>;

// 登録処理
export const B100180Create = (data: B100180CreateRequest) => {
  return RestClient.post("b100180/create", data);
};

export type B100180UpdateRequest = {
  whtankaKbn: string;
  whtankaCd: string;
  // 明細
  b100180UpdateFieldList: B100180UpdateMeiRequest[];
} & Partial<{}>;

export type B100180UpdateMeiRequest = {
  height: string;
} & Partial<{
  width1: string;
  width2: string;
  width3: string;
  width4: string;
  width5: string;
  width6: string;
  width7: string;
  width8: string;
  width9: string;
  width10: string;
  width11: string;
  width12: string;
  width13: string;
  width14: string;
  width15: string;
  width16: string;
  width17: string;
  width18: string;
  width19: string;
  width20: string;
  width21: string;
  width22: string;
  width23: string;
  width24: string;
  width25: string;
  width26: string;
  width27: string;
  width28: string;
  width29: string;
  width30: string;
  width31: string;
  width32: string;
  width33: string;
  width34: string;
  width35: string;
  width36: string;
  width37: string;
  width38: string;
  width39: string;
  width40: string;
  width41: string;
  width42: string;
  width43: string;
  width44: string;
  width45: string;
  width46: string;
  width47: string;
  width48: string;
  width49: string;
  version: string;
}>;

// 更新処理
export const B100180Update = (data: B100180UpdateRequest) => {
  return RestClient.put("b100180/update", data);
};

export type B100180DeleteRequest = {
  whtankaKbn: string;
  whtankaCd: string;
  // 明細
  b100180DeleteFieldList: B100180DeleteMeiRequest[];
} & Partial<{}>;

export type B100180DeleteMeiRequest = {
  height: string;
  version: string;
} & Partial<{}>;

// 削除処理
export const B100180Delete = (data: B100180DeleteRequest) => {
  return RestClient.delete("b100180/delete", { data: data });
};
